import { render, staticRenderFns } from "./error-box.vue?vue&type=template&id=477e33b3&"
import script from "./error-box.vue?vue&type=script&lang=ts&"
export * from "./error-box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports